import type { Texte } from './de'

/** Texte der Oberfläche, Englisch. Vollständigkeit erzwingt der Typ `Texte`. */
export const en: Texte = {
  'anmeldung.untertitel': 'Content',
  'anmeldung.email.zeigen': 'Sign in with email + password',
  'anmeldung.email.verbergen': 'Hide email sign-in',
  'anmeldung.email.platzhalter': 'email@example.com',
  'anmeldung.passwort.platzhalter': 'Password',
  'anmeldung.absenden': 'Sign in',
  'anmeldung.laeuft': 'Signing in…',
  'anmeldung.fehlgeschlagen': 'Sign-in failed',
  'anmeldung.mit': 'Sign in with {anbieter}',
  'anmeldung.keinWeg': 'No sign-in method is set up on this instance. Please contact the person who runs it.',
  'anmeldung.vorbereiten': 'Preparing sign-in …',
  'anmeldung.verarbeiten': 'Completing sign-in …',
  'anmeldung.zurueck': 'Back to sign-in',
  'anmeldung.konto': 'Create account',
}
